import { ExperienceSource } from 'model/IExperience';

import { formatPrice } from './formatPrice';

export function getPricePerPerson(
  experience: ExperienceSource,
  selectedNrOfAdults: number,
  selectedNrOfChildren = 0,
) {
  const searchablePrices = experience?.pricing?.searchable_price;
  const guests = selectedNrOfAdults + selectedNrOfChildren;
  const ppPrice =
    searchablePrices?.[guests] ??
    experience?.pricing?.advertised_price_origin?.amount?.value;
  const discount = experience?.experienceDiscount?.discount;
  return discount ? ppPrice * (1 - discount) : ppPrice;
}

export default function (
  experience: ExperienceSource,
  currency: string,
  selectedNrOfAdults: number,
  selectedNrOfChildren = 0,
  round = false,
): string {
  const ppPriceWithDiscount = getPricePerPerson(
    experience,
    selectedNrOfAdults,
    selectedNrOfChildren,
  );

  return formatPrice(ppPriceWithDiscount, currency, { rounded: round });
}
